module.exports = __webpack_public_path__ + "static/img/AlyssaHealy.ef582c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/AlyssaHealy.jpg
// module id = oYvj
// module chunks = 0